import React, { useEffect, useState } from 'react';
import {
  BusinessDetails,
  BasicInfo,
  Social,
  Communication
} from '../../components/Profile';
import './Profile.scss';
import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import { GetUserProfileType } from '../../redux/auth/authTypes';
import { resetUserProfiledata } from '../../redux/auth';
import { Loader } from '../../components/commons';

type AppProps = {
  userProfileData: GetUserProfileType;
  userType: number | null;
  fetching: boolean;
  dispatchResetUserProfiledata:()=>void
}

type ProfileTabs = {
  name: string;
  label: string;
}

const tabs: ProfileTabs[] = [
  {
    name: 'Basic Info',
    label: 'basic-info'
  },
  {
    name: 'Communication',
    label: 'communication'
  },
  /* {
    name: 'Business Details',
    label: 'business-details'
  }, */
  {
    name: 'Social',
    label: 'social'
  }
]

const Profile = ({ userProfileData, userType,dispatchResetUserProfiledata,fetching }: AppProps) => {

  const { basic_info, communication, social } = userProfileData;

  const [activeTab, setActiveTab] = useState<string>(tabs[0].label);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  useEffect(() => {
  //  dispatchResetUserProfiledata() 
  }, [])
  
  const renderTabs = () => {
    let finalTab = tabs.map((tab: ProfileTabs) => {
      return (
        <div
          className="tab-style mr-5 "
          key={tab.label}
          onClick={() => { handleTabChange(tab.label) }}
        >
          <div className={`tab-header ${ activeTab === tab.label ? "active" : "" }`}>{tab.name}</div>
          <div
            className={`${ activeTab === tab.label
              ? "active-tab-bottom-border"
              : "not-active-tab-bottom-border"
              }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  }

  let component = <BasicInfo
    basicInfo={basic_info}
  />

  if (activeTab === 'communication') {
    component = <Communication
      communication={communication}
    />
  } else if (activeTab === 'social') {
    component = <Social
      social={social}
    />
  }

  /*  else if (activeTab === 'business-details') {
     component = <BusinessDetails /> */
//   if (fetching) {
//   <Loader/>
// }
  return (
    <>
      <h2 className="mb-3">Profile</h2>
      <div className="tab-container d-flex flex-row justify-content-start align-items-center">
        {renderTabs()}
      </div>
      <div className="tab-detail-container ml-3">
        {component}
      </div>
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  userProfileData: state.auth.userProfiledata,
  userType: state.auth.userType,
  fetching: state.auth.fetching
})
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetUserProfiledata:()=>dispatch(resetUserProfiledata())
})

export default connect(mapStateToProps,mapDispatchToProps)(Profile);